module.exports = __webpack_public_path__ + "static/moloch-5e212af708192a4b2cd8523bedee77a3.jpg";